import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { HowItWorks } from "@/components/HowItWorks";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { MobileContactButton } from "@/components/MobileContactButton";
import { Seo } from "@/components/Seo";

const Index = () => {
  return (
    <>
      <Seo
        title="Upgrade Skills Ltd | English & Maths Courses in Rainham, Essex"
        description="Build skills & boost employability with practical English & Maths Level 1–2 courses plus workshops. Serving Rainham & Essex."
        path="/"
      />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:text-sm focus:font-medium"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content">
        <Hero />
        <Services />
        <HowItWorks />
        <About />
        <Contact />
      </main>
      <Footer />
      <CookieConsent />
      <MobileContactButton />
    </>
  );
};

export default Index;